import React, { createContext, useReducer } from "react";
import { reducer } from "./globalReducer";
export const GlobalContext = createContext();

const GlobalProvider = ({ children }) => {

    let localGlobalContext = localStorage.getItem("globalContext");
    if (!localGlobalContext) {
        localGlobalContext = {
            activeMenu: "dashboard",
            userData: {}
        }
    }else{
        localGlobalContext = JSON.parse(localGlobalContext)
    }

    const [contextData, dispatch] = useReducer(reducer, localGlobalContext);

    localStorage.setItem("globalContext", JSON.stringify(contextData));

    return (
        <GlobalContext.Provider value={{ contextData, dispatch }}>
            {children}
        </GlobalContext.Provider>
    );
};

export default GlobalProvider;
